<template>
<div>
  <in-wrapper>
    <in-ibox v-if="invoice.invoice">
      <div slot="title" class="p-sm m-t-n">
        <b>Invoice {{ invoice.invoice.InvoiceNumber }}</b>
        <router-link :to="'/admin/billing/invoice/' + invoice.id + '/edit'"
                     class="btn btn-primary btn-xs m-l-sm"
                     v-if="invoice.invoice.Status === 'DRAFT'"
        ><i class="fa fa-edit"></i> Edit</router-link>
        <span v-if="invoice.invoice.Status === 'DRAFT'">
          <button class="btn btn-danger btn-sm pull-right m-l-xs" @click="deleteInvoice"><i class="fa fa-remove"></i> Delete</button>
          <button
            :disabled="!invoice.invoice.AmountDue > 0"
            class="btn btn-primary btn-sm pull-right"
            @click="updateInvoice({Status: 'AUTHORISED'}, 'Do you want to authorise this invoice')
          "><i class="fa fa-check"></i> Authorise</button>
        </span>
        <span v-else-if="invoice.invoice.Status === 'AUTHORISED'">
          <button class="btn btn-danger btn-sm pull-right m-l-xs" @click="deleteInvoice"><i class="fa fa-remove"></i> Void</button>
        </span>
      </div>
      <div slot="content">
        <div class="row">
        <div class="col-lg-6"></div>
        <div class="col-lg-6 text-right">
          <h4>Invoice number: {{ invoice.invoice.InvoiceNumber }}</h4>
          <span>{{ invoice.invoice.Reference }}</span>
          <address>
            <span v-if="invoice.client">
              <strong class="text-navy">{{ invoice.client.name }} <i class="fa fa-link"></i></strong><br><br>
            </span>
            <span>
              <strong>{{ invoice.invoice.Contact.Name }}</strong><br>
              {{ invoice.invoice.Contact.EmailAddress }}
            </span>
          </address>
          <p>
            <span>
              <strong>Invoice Date:</strong> {{ invoice.invoice.DateString | aTime }}<br>
              <strong>Due Date:</strong> {{ invoice.invoice.DueDateString | aTime }}<br>
              <strong>Status: </strong> <span :class="'invoice-status invoice-' + invoice.invoice.Status">{{ invoice.invoice.Status }}</span><br>
              <a class="label label-primary" v-if="invoice.url" :href="invoice.url" target="_blank"><i class="fa fa-file-pdf"></i> Check invoice</a>
            </span>
          </p>
        </div>
      </div>
        <div class="row">
          <div class="table-responsive m-t">
            <table class="table invoice-table">
              <thead>
              <tr>
                <th>Item</th>
                <th>Quantity</th>
                <th>Amount</th>
                <th>Tax</th>
                <th>Total</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in invoice.invoice.LineItems" :key="item.LineItemID">
                <td>
                  <div>
                    <span v-if="item.Item"><strong>{{ item.Item.Name }}</strong> ({{ item.Item.Code }})</span>
                    <span v-for="track in item.Tracking" :key="track.TrackingOptionID"><small>{{ track.Name}}: {{ track.Option }}</small></span>
                  </div>
                  <small><i class="fa"></i> {{ item.Description }}</small>
                </td>
                <td>{{ item.Quantity }}</td>
                <td>{{ item.UnitAmount }}</td>
                <td>{{ item.TaxAmount }}</td>
                <td>{{ item.LineAmount }}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <table class="table invoice-total">
            <tbody>
            <tr>
              <td><b>Sub Total:</b></td>
              <td>{{ invoice.invoice.SubTotal }} {{ invoice.invoice.CurrencyCode }}</td>
            </tr>
            <tr>
              <td><b>Tax:</b></td>
              <td>{{ invoice.invoice.TotalTax }} {{ invoice.invoice.CurrencyCode }}</td>
            </tr>
            <tr>
              <td><b>Total:</b></td>
              <td>{{ invoice.invoice.Total }} {{ invoice.invoice.CurrencyCode }}</td>
            </tr>
            <tr>
              <td><b>Amount Due:</b></td>
              <td>{{ invoice.invoice.AmountDue }} {{ invoice.invoice.CurrencyCode }}</td>
            </tr>
            <tr>
              <td><b>Amount Paid:</b></td>
              <td>{{ invoice.invoice.AmountPaid }} {{ invoice.invoice.CurrencyCode }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </in-ibox>
  </in-wrapper>
</div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Invoice',
  data () {
    return {
      invoice: {}
    }
  },
  mounted () {
    this.loadInvoice(this.$route.params.id)
  },
  methods: {
    async loadInvoice (id) {
      try {
        let invoice = await axios.get(`/billing/invoices/${id}`)
        this.invoice = invoice.data
        document.title = `Invoice: ${this.invoice.invoice.InvoiceNumber} :: PBN360 by Aphex Media`
      } catch (e) {}
    },
    async updateInvoice (obj, msg) {
      if (!confirm(msg)) return
      try {
        const invoice = await axios.patch(`/integrations/xero/invoices/${this.invoice.invoice.InvoiceNumber}`, obj)
        this.invoice = invoice.data
        this.$toastr.success('Invoice updated!')
      } catch (e) {
        this.$toastr.error('Update Failed', e)
      }
    },
    async deleteInvoice () {
      if (!confirm('Do you really want to delete/void the invoice?')) {
        return
      }
      try {
        await axios.delete(`/integrations/xero/invoices/${this.invoice.id}`)
        this.$toastr.success('Invoice deleted')
        await this.$router.push('/admin/billing/invoices')
      } catch (e) {
        this.$toastr.error('Unable to delete the invoice', e.response.data.error.msg)
      }
    }
  }
}
</script>

<style scoped>
.invoice-status {
  font-size: medium;
}
.invoice-PAID {
  color: green;
}
.invoice-AUTHORISED {
  color: orange;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Admin/Billing/Tabs/Billing/Invoice.vue